import { Tooltip } from 'antd';
import React, { Fragment } from 'react';
import { injectIntl } from 'react-intl';
import { countryType } from '../../../types';

function CountryColumnRenderer(props) {
  const { country } = props;
  if (country) {
    return (
      <Tooltip className="hint" placement="top" title={country.name}>
        <div className="text-center" data-label={props.intl.formatMessage({ id: 'Grid.Column.Country' })}>
          {country.iso_3166_2 && <span className={`flag-icon flag-icon-${country.iso_3166_2.toLowerCase()}`} />}
        </div>
      </ Tooltip>
    );
  }
  return (<Fragment />);
}

CountryColumnRenderer.propTypes = {
  country: countryType,
};

export default injectIntl(CountryColumnRenderer);



// WEBPACK FOOTER //
// ./src/components/common/Table/CountryColumnRenderer.js